(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.buttons.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/skeleton-parts/wager-skeleton.buttons.js');
"use strict";

const Paper = svs.ui.ReactPaper;
const SkeletonLine = svs.components.lbUi.SkeletonLine;
const WagerSkeletonButtons = () => React.createElement(Paper, {
  branding: "sport",
  className: "pg_my_bets_wager_fallback__grid__container_btns"
}, React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__container_btns__text"
}));
setGlobal('svs.components.tipsen.modularBase.WagerSkeletonButtons', WagerSkeletonButtons);

 })(window);